import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./styleCss/Login.css";
import { useState } from "react";
import { login } from "../api/login_api";
import Loading from "../components/loading/Loading";
import { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { faEye } from '@fortawesome/free-regular-svg-icons'
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { sidebarMenu } from '../utils/const'
import Swal from "sweetalert2";
import "../components/swalStyle/customStyle.css";
import {
  textSearchBtn,
  textResetBtn,
  textCreateBtn,
  colorSearchBtn,
  colorResetBtn,
  colorCreateBtn,
  iconSearchBtn,
  iconResetBtn,
  iconCreateBtn,
  hoverSearchBtn,
  hoverResetBtn,
  hoverCreateBtn,
  textSaveBtn,
  textCancleBtn,
  colorSaveBtn,
  colorCancleBtn,
  hoverSaveBtn,
  hoverCancleBtn,
  colorEditBtns,
  hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { ProfileContext, useSetProfile } from "../context/ProfileContext";
import { useSetAuth } from "../context/AuthContext";
import {
  alertKeySpaceBar,
  alertKeyLangTH,
  alertRequired,
  alertLoginSuccess,
  alertIncorrectLogin,
  alertError
} from "../components/alertValid/AlertValid.js"

function Login() {
  useButtonDynamicStyles(
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
);
  const navigate = useNavigate();
  const [inputPassword, setInputpassword] = useState("");
  const [checked, setChecked] = useState(false);
  const [inputUser, setInputuser] = useState("");
  const [visible, setVisible] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const {refreshProfile} = useSetProfile()
  
  const profile = useContext(ProfileContext)
  
  const { setToken } = useSetAuth();

  const handleUserChange = (e) => {
    setInputuser(e.target.value);
  };


  const handleInputChkThai = async (event) => {
    const thaiCharacterRegex = /[\u0E00-\u0E7F]/; // Thai character Unicode range

    if (event.target.value.includes(' ')) {
      event.target.value = event.target.value.replace(/\s/g, '');
      await alertKeySpaceBar();
      return;
  }
  
    if (thaiCharacterRegex.test(event.target.value)) {
      event.target.value = ""; // Clear input if it contains Thai characters
      await alertKeyLangTH();
      return;
    }
  };
  const handlePasswordChange = (e) => {
    setInputpassword(e.target.value);
  };
  

  const validateUserPass = () => {
    if (inputUser&&inputPassword) {
      return true;
    }
    return false;
  };

  const handleForgotPass = () => {
    navigate(`/forgotPassword`);
  };

  const handleSubmit = async () => {
    if (validateUserPass()) {
      loginUser();
    }
    else {
      await alertRequired();
    }
  };

  const handleKeyPress = async (e) => {
    if (e.key === 'Enter') {
      validateUserPass();
      loginUser();
      handleSubmit();
    }
    if (e.key === ' ') {
      await alertKeySpaceBar();
    }
  };

  const save_Datauser = (tokenBackoffice) => {
    if (checked) {
      let dataarray = [];
      dataarray.push({
        username: inputUser,
        password: inputPassword,
      });
      localStorage.setItem("SaveLogin", JSON.stringify(dataarray));
      // localStorage.setItem("tokenBackoffice", tokenBackoffice);
    }
  };
    
  const mapRoutePageFromRole = (routeKey) => {
    const filterMenu = sidebarMenu?.filter(item => item.key == routeKey)

    let key = '/infoShortcuts'
    // check nested 3 level
    // if(filterMenu.length >  0 && filterMenu[0].subMenu?.length > 0 && filterMenu[0].subMenu[0]?.subMenu.length > 0) {
    if(filterMenu.length >  0 && filterMenu[0].subMenu?.length > 0 ) {
      // check if there is nested level 
      if(Array.isArray(filterMenu[0].subMenu[0]?.subMenu) &&filterMenu[0].subMenu[0]?.subMenu?.length > 0){
        key = filterMenu[0].subMenu[0]?.subMenu[0]?.path
      }else{
        key = filterMenu[0].subMenu[0]?.path
      }
  
    }else{
      key = filterMenu[0].path
    }
    return  key
  }

  const loginUser = async () => {
    var data = {
      username: inputUser,
      password: inputPassword,
    };
    try {
      // ------
      await setLoading(true);

      const respon = await login(data);
      if (respon && respon.status == 200) {
        localStorage.setItem("tokenBackoffice", respon.data.token);
        sessionStorage.setItem("tokenBackoffice", respon.data.token);
        refreshProfile(respon.data.token).then(rest => {

          setToken(respon.data.token);
          
          save_Datauser(respon.data.token);

          const menuList = rest?.role?.menu_lists
          // let defaultRedirectMenu = '/backoffice/infoShortcuts'
          let defaultRedirectMenu = '/infoShortcuts'

          if(Array.isArray(menuList) && menuList.length > 0) {
            defaultRedirectMenu = mapRoutePageFromRole(menuList[0].key)

          }

          
          Swal.fire({
            iconHtml: '<img src="https://img2.pic.in.th/pic/ic-success-green.png">',
            title: "Login Success.",
            text: "เข้าสู่ระบบสำเร็จ",
            confirmButtonText: "CLOSE",
          }).then((result) => {
            // window.location.href = defaultRedirectMenu;
            navigate('/'+defaultRedirectMenu);
          });
        }).catch(err => {

          Swal.fire({
            iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
            title: "Incorrect username or password.",
            text: "Username/Password ไม่ถูกต้อง",
            confirmButtonText: "OK",
          }).then((result) => {});
        }).finally(() => setLoading(false))
      }
      else {


        Swal.fire({
          iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
          title: "Incorrect username or password.",
          text: "Username/Password ไม่ถูกต้อง",
          confirmButtonText: "OK",
        }).then((result) => {});
      }
     
      // ---
    } catch (error) {
      Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: 'An error occurred! Please try again.',
        confirmButtonText: 'OK',
      })
      .then((result) => {});
      console.log(error);
    }
    await setLoading(false);
  };

  useEffect(() => {
    if (localStorage.getItem("SaveLogin")) {
      var saveLogindata = localStorage.getItem("SaveLogin");
      var setDatalogin = JSON.parse(saveLogindata);
      setInputuser(setDatalogin[0].username);
      setInputpassword(setDatalogin[0].password);
    }
  }, []);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div id="login">
          <div className="container-fluid height100">
            <div className="row justify-content-center height100">
              <div className="col-12 flex-direction login02">
                <div className="card-login">
                  <div className="row">
                    <div className="col-12 d-flex justify-content-center">
                      <img src="assets/images/logo-asp.png" className="logo-login" alt="" />
                    </div>
                    <div className="title-line"></div>
                    <div className="col-12 mt-3 mb-3 d-flex justify-content-start">
                      <label className="fontReg font-size05 line-height03 font-weight-bold colorBlack01">
                        LOGIN
                      </label>
                    </div>
                    <div className="col-12 p-0">
                        <div className="d-flex justify-content-between box-login">
                          <input
                            value={inputUser}
                            onChange={handleUserChange}
                            type="text"
                            className="inp-login font-size03"
                            id="user_name"
                            placeholder="Username"
                            onKeyDown={handleKeyPress}
                          />
                          <div
                            className="p-2"
                          >
                              <FontAwesomeIcon icon={faUser} />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mt-3 p-0">
                        <div className="d-flex justify-content-between box-login">
                          <input
                            onInput={handleInputChkThai}
                            value={inputPassword}
                            onChange={handlePasswordChange}
                            maxLength={30}
                            type={visible ? "text" : "password"}
                            className="inp-login font-size03"
                            id="password"
                            placeholder="Password"
                            onKeyDown={handleKeyPress}
                          />
                          <div
                            className="p-2 cursor-pointer"
                            onClick={() => setVisible(!visible)}
                          >
                            {visible ? (
                              <FontAwesomeIcon icon={faEye} />
                            ) : (
                              <FontAwesomeIcon icon={faEyeSlash} />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mt-4 p-0">
                        <button
                          onClick={() => handleSubmit()}
                          type="button"
                          className="btn btn-lg btn-login fontReg font-weight-bold font-size03"
                          // disabled={inputPassword.length < 6}
                        >
                          LOGIN
                        </button>
                      </div>
                      <div className="col-6 mt-2 d-flex justify-content-start p-0">
                        <button
                          onClick={handleForgotPass}
                          className="fontReg font-size03 colorBlue01 btn-fg-pass"
                        >
                          Forgot Password
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Login;